export default __webpack_public_path__ + "static/media/playbutton.43bf473d.svg";